import React, { useState, useEffect } from 'react';
import styles from '../../styles/components/KitSubscribe.module.css';

const KitSubscribe = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://f.convertkit.com/ckjs/ck.5.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      const response = await fetch('https://app.convertkit.com/forms/7211005/subscriptions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email_address: email,
        }),
      });

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        console.error('Subscription failed');
        // Handle error (e.g., show error message to user)
      }
    } catch (error) {
      console.error('Error:', error);
      // Handle error (e.g., show error message to user)
    }
  };

  if (isSubmitted) {
    return (
      <div className={styles.successMessage}>
        Success! Now check your email to confirm your subscription.
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={`seva-form formkit-form ${styles.subscribeForm}`}
    >
      <div className={styles.formWrapper}>
        <input
          className={styles.emailInput}
          name="email_address"
          aria-label="Email Address"
          placeholder="Email Address"
          required=""
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          type="submit"
          className={styles.subscribeButton}
        >
          Subscribe
        </button>
      </div>
    </form>
  );
};

export default KitSubscribe;